class Marquee {
  /**
   * Init marquee
   *
   * @param  {HTMLElement} marquee
   */
  marquee = null;

  constructor(marquee) {
    this.marquee = marquee
    this.update()
  }

  /**
   * Init marquee
   *
   * @param  {HTMLElement} marquee
   */
  update() {
    let width = 0
    const height = this.marquee.clientHeight
    const imgs = this.marquee.querySelectorAll('.original img')
    imgs.forEach((img) => {
      const imgWidth = img.getAttribute('width');
      const imgHeight = img.getAttribute('height');
      width += imgWidth / imgHeight * height
    })

    this.marquee.setAttribute('style', `--marquee-width:-${width}px;`)
  }
}

export default Marquee;
